"use client";
import { useEffect } from "react";
import { useABTestingView } from "../../../customHooks/clevertap/useABTestingView";
import { useSiteFnpChat } from "../../../customHooks/useFnpChat/useSiteFnpChat";

/** Loads the FNP chat client and hides Freshchat (see `body.fnp-chat-on` in globals.css). */
const FnpChatMount = () => {
  useSiteFnpChat();
  useEffect(() => {
    document.body.classList.add("fnp-chat-on");
    return () => document.body.classList.remove("fnp-chat-on");
  }, []);
  return null;
};

/**
 * Mounts the FNP chat client only when the CleverTap flag `showFNPChatForWeb` is on.
 * Renders nothing; the chat opens through `openSiteChat()`.
 * @returns {JSX.Element|null}
 */
const FnpChatLoader = () => {
  const { showFNPChatForWeb, recallABTestingHook } = useABTestingView();

  // The page initialises CleverTap after this layout-level component has already rendered,
  // so useABTestingView's first fetch finds no window.clevertap and stops. Once it exists, ask once more.
  useEffect(() => {
    const id = setInterval(() => {
      if (!window.clevertap) return;
      clearInterval(id);
      recallABTestingHook();
    }, 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return showFNPChatForWeb ? <FnpChatMount /> : null;
};

export default FnpChatLoader;
